// Prefix for all localStorage keys
const LOCAL_STORAGE_PREFIX = "IQEVSE_FLEET_CSMS";

// Centralized key map
export const LOCAL_STORAGE_KEYS = {
  THEME: `${LOCAL_STORAGE_PREFIX}_theme`,
  LANGUAGE: `${LOCAL_STORAGE_PREFIX}_language`,
  FILTERBAR_STATE: `${LOCAL_STORAGE_PREFIX}_filterbar_state`,
  GLOBAL_FILTERS: `${LOCAL_STORAGE_PREFIX}_global_filters`,
  FEATURE_ACCESS: `${LOCAL_STORAGE_PREFIX}_feature_access`,
};

/**
 * Stores a value in localStorage.
 * Automatically stringifies non-string values.
 * @param {string} key - The localStorage key.
 * @param {*} value - The value to store.
 */
export function setLocalStorage(key, value) {
  try {
    const serialized = typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(key, serialized);
  } catch {
    // localStorage write failed
  }
}

export function patchLocalStorage(key, updates) {
  try {
    const existing = getLocalStorage(key) || {};
    const currentData = typeof existing === "object" && existing !== null ? existing : {};
    const newData = { ...currentData, ...updates };
    setLocalStorage(key, newData);
  } catch {
    // localStorage write failed
  }
}

/**
 * Retrieves a value from localStorage.
 * Parses JSON if `parse` is true.
 * @param {string} key - The localStorage key.
 * @param {boolean} [parse=true] - Whether to parse the value as JSON.
 * @returns {*} - The retrieved value or null.
 */
export function getLocalStorage(key, parse = true) {
  try {
    const item = localStorage.getItem(key);
    if (!item) return null;
    return parse ? JSON.parse(item) : item;
  } catch {
    return null;
  }
}

/**
 * Removes a key from localStorage.
 * @param {string} key - The localStorage key.
 */
export function removeLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // localStorage remove failed
  }
}
